import { updateAtcLabel } from './relic-atc-label.js';
import { formatMoney, getMoneyFormat } from './relic-money.js';

function updateAffirm(pdp, variant, moneyFormat) {
  const el = pdp.querySelector('[data-relic-affirm-monthly]');
  if (!el) return;
  el.textContent = formatMoney(Math.round(variant.price / 12), moneyFormat);
}

function updateAtc(pdp, variant) {
  const input = pdp.querySelector('[data-relic-atc-variant-id]');
  const button = pdp.querySelector('[data-relic-atc-button]');
  const stickyButton = pdp.closest('.shopify-section')?.querySelector('[data-relic-atc-sticky]');

  if (!button && !stickyButton) return;

  const soldOut = Boolean(variant && !variant.available);
  const ready = Boolean(variant && variant.available);
  if (input) input.value = ready ? variant.id : '';

  if (button) {
    button.disabled = soldOut;
    updateAtcLabel(button, variant, pdp);
  }

  if (stickyButton) {
    stickyButton.disabled = soldOut;
    updateAtcLabel(stickyButton, variant, pdp);
  }
}

function updateGallery(pdp, variant) {
  if (!variant.featured_image) return;

  const gallery = pdp.querySelector('relic-gallery');
  if (!gallery || typeof gallery.setActiveIndex !== 'function') return;

  gallery.setActiveIndex(variant.featured_image.position - 1, { scrollSlides: true });
}

function updatePrice(pdp, variant, moneyFormat) {
  const priceEl = pdp.querySelector('[data-relic-price]');
  if (!priceEl) return;

  const currentEl = priceEl.querySelector('[data-relic-price-current]');
  const compareEl = priceEl.querySelector('[data-relic-price-compare]');
  const fromEl = priceEl.querySelector('[data-relic-price-from]');

  if (currentEl) {
    currentEl.textContent = formatMoney(variant.price, moneyFormat);
  }

  if (fromEl && !priceEl.hasAttribute('data-relic-price-keep-from')) {
    fromEl.hidden = true;
  }

  if (compareEl) {
    if (variant.compare_at_price > variant.price) {
      compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
      compareEl.hidden = false;
    } else {
      compareEl.hidden = true;
    }
  }
}

document.querySelectorAll('[data-relic-pdp]').forEach((pdp) => {
  const moneyFormat = getMoneyFormat(pdp);
  // Bind before the picker and purchase apps finish initializing.
  pdp.querySelectorAll('[data-relic-atc-button]').forEach((button) => {
    updateAtcLabel(button, { price: Number(button.dataset.atcPrice), available: !button.disabled }, pdp);
  });

  pdp.addEventListener('variant:change', (e) => {
    const { variant, userInitiated } = e.detail;
    updateAtc(pdp, variant);
    if (!variant) return;
    updatePrice(pdp, variant, moneyFormat);
    if (userInitiated) {
      updateGallery(pdp, variant);
    }
    updateAffirm(pdp, variant, moneyFormat);
  });
});
